export enum ReweighLogDetailsViewType {
  DEFAULT = 'default',
  DISPUTES = 'disputes',
  LOG_HEADERS_GRID = 'logHeaderGrid',
}
